<template>
  <div class="stat-alarm">
    <StatPage
      :formModel="formModel"
      :requestData="requestData"
      :formButton="formButton"
      :deviceModelBusiType="1"
    />
  </div>
</template>

<script>
import { merge } from 'lodash';
import { getAlarmData } from '@/api/stat';
import { canvasToImg, downFile, dayTime } from '@/utils/utils';

export default {
  name: 'StatAlarm',
  components: {
    StatPage: () => import('../components/stat-common')
  },
  data() {
    return {
      requestData: {},
      formModel: {
        sn: [],
        taskId: [],
        officeId: [],
        alarmType: [],
        busiType: [],
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()],
        deviceModel: []
      },
      formButton: [
        {
          text: '查询',
          event: this.search
        },
        {
          text: '导出',
          code: '010611',
          loading: false,
          event: this.hisExport
        }
      ]
    };
  },
  methods: {
    getAlarmDataPro() {
      return getAlarmData(
        merge(
          {
            beginTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[0],
            endTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[1]
          },
          this.formModel
        )
      );
    },
    search() {
      this.getAlarmDataPro().then(res => {
        this.requestData = res.data;
      });
    },
    hisExport(op) {
      op.loading = true;
      this.getAlarmDataPro().then(res => {
        this.requestData = res.data;
        this.$nextTick().then(() => {
          canvasToImg().then(imgs => {
            downFile({
              url: '/stat/genAlarmDataReport',
              method: 'post',
              data: merge(
                {
                  beginTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[0],
                  endTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[1],
                  pics: imgs
                },
                this.formModel
              )
            }).finally(() => {
              op.loading = false;
            });
          });
        });
      });
    }
  }
};
</script>
